import { ONBOARDING } from "../actions/types";
import { takeLatest, call, put } from "redux-saga/effects";
import { verifySuccess, verifyFail } from "../actions/Onboarding";
import { loadingFinish } from "../actions/Loading";
import { logout } from "../actions/Auth";
import history from "../../helpers/history";
import { updateUser } from "../actions/Auth";
import axios from "axios";
import { authHeader, authUser } from "../../lib/authHeader";
import { toast } from "react-toastify";
import {
  submitDetailsSuccess,
  submitDetailsFail,
  setPinSuccess,
} from "../actions/Onboarding";
import { updateProfile } from "../actions/Settings";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}agent`;

function* verifyBvn({ payload, history }) {
  const apiUrl = `${API_BASE}/profile/kyc/verify`;
  const { token } = JSON.parse(localStorage.getItem("user"));
  localStorage.setItem("onboarding-page", "1");

  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      sessionStorage.setItem("bvn", "true");
      sessionStorage.setItem("personal-info", JSON.stringify(payload));

      const data = { data: result.data, verified: true };
      yield put(verifySuccess(data));

      // history.push("/onboarding/personal-info");
      toast.success(result.data.message);
      yield put(updateProfile());
      history.push("/onboarding/personal-info");
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
    yield put(verifyFail());
  } finally {
    yield put(loadingFinish());
  }
}

function* handleSubmitDetails({ payload, history }) {
  // const flag = action.payload.flag;
  const { token } = JSON.parse(localStorage.getItem("user"));
  // if (flag === 1) {
  //   localStorage.setItem("onboarding-page", "2");
  // } else {
  //   localStorage.setItem("onboarding-page", "3");
  // }

  const apiUrl = `${API_BASE}/profile/kyc/update`;
  // const { bvn } = localStorage.getItem("bvn")
  //   ? JSON.parse(localStorage.getItem("bvn"))
  //   : "";

  const apiCall = async () => {
    // const data = {
    //   ...action.payload,
    //   user_id: user.id,
    //   bank_verification_number: bvn,
    // };
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      sessionStorage.setItem("submit", "true");
      // const payload = { data: result.data, verified: true };
      // yield put(submitDetailsSuccess(payload));
      // yield put(updateProfile());
      history.push("/onboarding/create-pin");
      // if (flag === 1) {
      //   history.push("/onboarding/extra-info");
      // } else {
      //   history.push("/onboarding/create-pin");
      // }
    } else {
      throw result.data.message;
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);

    // yield put(submitDetailsSuccess());
    yield put(submitDetailsFail());
    // toast.error(err || "An error occured")
  } finally {
    yield put(loadingFinish());
  }
}

function* handleSetPin({payload, history}) {
  const apiUrl = `${API_BASE}/profile/transaction/pin/set`;
  const { token } = JSON.parse(localStorage.getItem("user"));
  const { user } = JSON.parse(localStorage.getItem("user"));

  const apiCall = async () => {
    const data = { ...payload, user_id: user.id };
    try {
      const result = await axios.post(apiUrl, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    // yield put(setPinSuccess(true));
    // toast.success("Pin created successfully")

    const result = yield call(apiCall);

    const delay = (time) => new Promise((resolve) => setTimeout(resolve, time));
    if (result.status !== "error") {
      // const payload = { data: result.data, setPin: true };
      // yield put(setPinSuccess(payload));
      // localStorage.setItem("onboarding-page", "5");
      // yield put(updateUser());

      toast.success("Pin created successfully");
      yield call(delay, 2000);
      yield put(logout());
    } else {
      // yield put(submitDetailsFail(result.data.message));
      throw result.data.status;
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

const onboardingSaga = [
  takeLatest(ONBOARDING.VERIFY, verifyBvn),
  takeLatest(ONBOARDING.SUBMIT_DETAILS, handleSubmitDetails),
  // takeLatest(ONBOARDING.PRE_SUBMIT_DETAILS, handlePreSubmitDetails),

  takeLatest(ONBOARDING.SET_PIN, handleSetPin),
];

export default onboardingSaga;
